import { Language } from '../../core/interfaces/language';

/**
 * @constant
 * @description Constante con las opciones disponibles del idioma.
 */
export const LANGUAGES: Language[] = [
  { lang: 'en', label: 'LANGUAGE.ENGLISH', flag: 'assets/images/flags/us.svg' },
  { lang: 'es', label: 'LANGUAGE.SPANISH', flag: 'assets/images/flags/co.svg' },
];
